<template>
  <!-- 经销商列表管理 -->
  <div class="Content">
    <el-card>
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
        :inline="true"
      >
        <el-form-item label="品牌">
          <el-select v-model="form.brand" filterable @change="brandChange">
            <el-option label="全部" value=""> </el-option>
            <el-option
              v-for="item in BrandList"
              :key="item.brand"
              :label="item.brand"
              :value="item.brand"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="大区">
          <el-select v-model="form.zone" filterable>
            <el-option label="全部" value=""> </el-option>
            <el-option
              v-for="item in ZoneList"
              :key="item.zone"
              :label="item.zone"
              :value="item.zone"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经销商名称">
          <el-input
            v-model="form.dealername"
            placeholder="请输入企业代码或者经销商名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="searchHandel">搜 索</el-button>
          <el-button @click="downloadHandel">导 出</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <el-table
        :data="handleTable"
        style="width: 100%"
        border
        size="mini"
        @sort-change="sortChange"
      >
        <el-table-column prop="brand" label="品牌"> </el-table-column>
        <el-table-column prop="zone" label="区域"> </el-table-column>
        <el-table-column prop="province" label="省"> </el-table-column>
        <el-table-column prop="city" label="市"> </el-table-column>
        <el-table-column prop="cid" label="企业代码"> </el-table-column>
        <el-table-column prop="dealername" label="企业名称"> </el-table-column>
        <el-table-column prop="ttime" label="创建时间"> </el-table-column>
        <el-table-column prop="balance" label="隐私号余额" sortable="custom">
          <template slot-scope="scope">
            <div v-if="!scope.row.balance">
              未开通
            </div>
            <div
              v-else
              :style="{
                color:
                  Math.round(scope.row.balance * 100) / 100 < 150 ? 'red' : ''
              }"
            >
              {{ Math.round(scope.row.balance * 100) / 100 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="ToLogin(scope.row)"
              type="text"
              size="small"
              :class="[scope.row.click ? '' : 'duckCss']"
            >
              快速登录
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { exportExcel } from "../../utils/DownLoadFail.js";
export default {
  data() {
    return {
      form: {
        brand: "",
        zone: "",
        dealername: ""
      },
      ZoneList: [],
      BrandList: [],
      DealernameList: [],
      handleTable: [],
      total: 10,
      pageindex: 1,
      sortType: null
    };
  },
  methods: {
    // 品牌切换
    brandChange(e) {
      console.log(e);
      this.form.zone = "";
      this.ZoneList = [];
      this.getZoneFun();
    },
    // 快速登录
    ToLogin(data) {
      console.log(data);
      data.click = false;
      window.open(window.location.origin + "/LoginIn.aspx?id=" + data.cid);
    },
    sortChange(e) {
      this.sortType = e.order;
      switch (e.order) {
        case "descending":
          this.handleTable = [...this.DealernameList]
            .sort((a, b) => {
              return a.balance - b.balance;
            })
            .slice((this.pageindex - 1) * 10, this.pageindex * 10);
          break;
        case "ascending":
          this.handleTable = [...this.DealernameList]
            .sort((a, b) => {
              return b.balance - a.balance;
            })
            .slice((this.pageindex - 1) * 10, this.pageindex * 10);
          break;
        default:
          this.handleTable = [...this.DealernameList].slice(
            (this.pageindex - 1) * 10,
            this.pageindex * 10
          );
          break;
      }
    },
    searchHandel() {
      console.log("搜搜");
      this.pageindex = 1;
      this.getDealerListFun();
    },
    async downloadHandel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let TABLEHEAD = [
        "品牌",
        "区域",
        "省",
        "市",
        "企业代码",
        "企业名称",
        "创建时间",
        "隐私号余额"
      ];
      let TABLEHEADFILED = [
        "brand",
        "zone",
        "province",
        "city",
        "cid",
        "dealername",
        "ttime",
        "balance"
      ];
      let TABLEHEADDATA = [...this.DealernameList];
      await exportExcel(
        TABLEHEAD,
        TABLEHEADFILED,
        TABLEHEADDATA,
        new Date().getTime()
      );
      loading.close();
    },
    currentChange(e) {
      console.log(e);
      this.pageindex = e;
      switch (this.sortType) {
        case "descending":
          this.handleTable = [...this.DealernameList]
            .sort((a, b) => {
              return a.balance - b.balance;
            })
            .slice((this.pageindex - 1) * 10, this.pageindex * 10);
          break;
        case "ascending":
          this.handleTable = [...this.DealernameList]
            .sort((a, b) => {
              return b.balance - a.balance;
            })
            .slice((this.pageindex - 1) * 10, this.pageindex * 10);
          break;
        default:
          this.handleTable = [...this.DealernameList].slice(
            (this.pageindex - 1) * 10,
            this.pageindex * 10
          );
          break;
      }
    },
    // 获取品牌
    getBrandFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getBrand", {
          data: JSON.stringify(this.$Help({}))
        })
        .then(res => {
          loading.close();
          console.log(res);
          this.BrandList = res.data.filter(item => item.brand);
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },
    // 获取区域
    getZoneFun() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getZone", {
          data: JSON.stringify(
            this.$Help({
              brand: this.form.brand
            })
          )
        })
        .then(res => {
          loading.close();
          this.ZoneList = res.data.filter(item => item.zone);
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    },
    // 获取经销商
    getDealerListFun() {
      // type  存在， 则为下载
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$axios
        .Postdata("manage/Voicerecordreport.asmx/getDealerList", {
          data: JSON.stringify(
            this.$Help({
              pageindex: this.pageindex,
              pagesize: "0",
              brand: this.form.brand,
              zone: this.form.zone,
              dealername: this.form.dealername
            })
          )
        })
        .then(res => {
          loading.close();
          res.data.detail.forEach(element => {
            element.click = true;
          });
          this.DealernameList = res.data.detail;
          this.handleTable = [...this.DealernameList].slice(
            (this.pageindex - 1) * 10,
            this.pageindex * 10
          );
          this.total = res.data.totalcount * 1;
        })
        .catch(err => {
          loading.close();
          this.$message("网络错误，请重试");
        });
    }
  },
  created() {
    this.getBrandFun();
    this.getZoneFun();
    this.searchHandel();
  }
};
</script>

<style scoped>
.pagination {
  padding-top: 20px;
  text-align: right;
}

.duckCss {
  color: #999;
}
</style>
